// AppRouter.js
import React from 'react';
import { BrowserRouter, Router, Route, Switch, Redirect } from 'react-router-dom';
import App from './app';
import Landing from './landing';
import { useSelector } from 'react-redux';
import { OrderProvider } from './context/OrderContext';
import PageNotFound from './pages/PageNotFound';
import { history } from './history';
import CustomerDisplayViewer from './customerDisplay/CustomerDisplayViewer';

const AppRouter = () => {
  const user = useSelector((state) => state.user);
  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/customer-display/:displayId" component={CustomerDisplayViewer} />
        <Route path="/customer-display" component={CustomerDisplayViewer} />
        <Route
          path="/"
          render={() =>
            user.user?._id ? (
              <OrderProvider>
                <App />
              </OrderProvider>
            ) : (
              <Landing />
            )
          }
        />
        <Route component={PageNotFound} />
      </Switch>
    </Router>
  );
};

export default AppRouter;
